// App.js
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AuthProvider } from "./Components/auth/authContext";
import { Helmet } from "react-helmet";
// Import your AuthContext & Authentication
import ProtectedRoute from "./Components/auth/protectedRoute";
 
import Services from "./Components/Services";
import Login from "./Components/auth/Login";
import Register from "./Components/auth/Register";
// Navigation
import About from "./Components/About/About";
import Hero from "./Components/Hero";
import Products from "./Components/Products";
import Contact from "./Components/Contact/Contact";
import Careers from "./Components/Contact/Careers";
// Footers
import Footer from "./Components/Footer/Footer";
import End from "./Components/Footer/End";
// Navigation
import NAVIE from "./Components/Home/Navbar";
// Warning popup
import WIPPopup from "./Components/Warnings/WIPPopup";
import { useState } from "react";
import FAQ from "./Components/FAq/FAQ";



function App() {
  const [showWIPPopup, setShowWIPPopup] = useState(false);

  const closeWIPPopup = () => {
    setShowWIPPopup(false);
  };
  return (
    <AuthProvider>
      <Router>
        <div className="App ">
          {/* Navbar */}
    <NAVIE />
    {/* Source files */}
    {/* <WIPPopup visible={showWIPPopup} onClose={closeWIPPopup} /> */}

          <Helmet>
            <script src="assets/vendor/purecounter/purecounter.js"/>
            <script src="assets/vendor/aos/aos.js"/>
            <script src="assets/vendor/bootstrap/js/bootstrap.bundle.min.js"/>
            <script src="assets/vendor/glightbox/js/glightbox.min.js"/>
            <script src="assets/vendor/isotope-layout/isotope.pkgd.min.js"/>
            <script src="assets/vendor/swiper/swiper-bundle.min.js" />
            <script src="assets/vendor/php-email-form/validate.js" />
            <script src="assets/js/main.js" type="text/javascript" />
          </Helmet>

          <Route exact path="/" component={Hero}/>
          <main id="main">
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
           <Route path="/About" component={About} />
            <Route path="/Services" component={Services} />
            <Route path="/Products" component={Products} />
            <Route path="/Contact" component={Contact} />
            <Route path="/Careers" component={Careers} />
            <Route path="/faqs" component={FAQ} />
          </Switch>
          </main>

          <footer id="footer">
        
              <Footer />
         
            <End />
          </footer>

          <a
            href="#"
            class="back-to-top d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-arrow-up-short"></i>
          </a>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
